import React from 'react';
import DepartmentTopResearcherCard from '@/features/department/components/DepartmentTopResearcherCard';

function yearRangeLabel(startYear, endYear) {
    if (startYear == null || endYear == null) return null;
    return startYear === endYear ? `(${startYear})` : `(${startYear}-${endYear})`;
}

export default function DepartmentTopPublishingResearcherCard({ deptId, startYear, endYear }) {
    return (
        <DepartmentTopResearcherCard
            title="Top Publishing Researcher"
            yearRangeLabel={yearRangeLabel(startYear, endYear)}
            deptId={deptId}
            startYear={startYear}
            endYear={endYear}
            endpoint={deptId ? `/rm/v1/department/${deptId}/top_publishing` : "/rm/v1/department/top_publishing"}
        />
    );
}

